/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_2_1Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_3_table_rows_2_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_2_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test an independent copy, save it and reopen in Excel before changing your usual workflow.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_3_table_rows_2_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_2_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先测试独立副本，保存并在 Excel 中重新打开，再考虑改变日常流程。`)
};

/**
* | output |
* | --- |
* | "Test an independent copy, save it and reopen in Excel before changing your usual workflow." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_2_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_3_table_rows_2_1 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_2_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_2_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_3_table_rows_2_1(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_3_table_rows_2_1(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_3_table_rows_2_1 as "gc.search_guides.what_is_gridcraft.sections.3.table.rows.2.1" }